import {StatusCollector} from "scorm/common/StatusCollector";
import {EncryptionService} from "encryption/EncryptionService";
import {Assert} from "common/Assert";

/**
 * This registry stores data for all lesson sco, started
 * at least one time by the user.
 * In due to is registry should be refactored to contain all sco data at
 * beginning of the course.
 *
 * @param {Function} ScoDataClass class for the stored sco data
 * @constructor
 */
export function ScoRegistry( ScoDataClass ) {

    Assert.checkArgument( ScoDataClass );
    Assert.checkArgumentType( ScoDataClass, "function" );

    const encryptionService = new EncryptionService(),
          statusCollector = new StatusCollector(),
          scoValueMap = new Map();

    let resultRelevantScos = [];

    function initialize( encryptedData ){

        let data = decryptData( encryptedData );
        if (data.length === 0) {
            return false;
        }

        let scoData,
            scoId;

        const scoEntries = data.split('*');
        scoEntries.forEach( (scoEntry) => {
            scoData = new ScoDataClass();
            if( scoData.importFromString( scoEntry, '$') ) {
                scoId = scoData.getValue("lesson_id");
                if( scoId && scoId.length > 0 ) {
                    scoValueMap.set( scoId, scoData );
                }
            }
        });

        return true;
    }

    function decryptData( encryptedData ) {

        if( !encryptedData || encryptedData.length === 0 ) {
            return "";
        }

        // using indexOf insted of replace because of an IE6-Bug
        let compressedData = encryptedData,
            pos = compressedData.indexOf("~");

        while (pos >= 0) {
            compressedData = compressedData.substr(0, pos) + "%" + compressedData.substr(pos + 1);
            pos = compressedData.indexOf("~");
        }

        return encryptionService.decryptData(compressedData);
    }

    function collectSuspendData() {

        let sSuspendData = "";
        forEachInitializedSco((scoId, scoData) => {

            if (sSuspendData.length > 0) {
                sSuspendData += '*';
            }

            sSuspendData += scoData.exportToString('$');
        });

        return encryptData(sSuspendData);
    }

    function encryptData( data ) {

        let encryptedData = encryptionService.encryptData(data),

            // using indexOf instead of replace because of an IE6-Bug
            pos = encryptedData.indexOf("%");

        while (pos >= 0) {
            encryptedData = encryptedData.substr(0, pos) + "~" + encryptedData.substr(pos + 1);
            pos = encryptedData.indexOf("%");
        }

        return encryptedData;
    }

    function forEachInitializedSco( callback ) {

        let keyIterator = scoValueMap.keys(),
            result = keyIterator.next();

        while (!result.done) {
            const scoId = result.value;
            callback(scoId, scoValueMap.get(scoId));
            result = keyIterator.next();
        }
    }

    function forEachInitializedScoThatIsRelevantForResult( callback ) {

        let keyIterator = scoValueMap.keys(),
            result = keyIterator.next();

        while (!result.done) {
            const scoId = result.value;

            if( isResultRelevant( scoId ) && callback(scoId, scoValueMap.get(scoId)) === "break" ) {
                break;
            }

            result = keyIterator.next();
        }
    }

    function isResultRelevant( scoId ) {

        // If the sco-id list is empty then all SCOs are relevant.
        if( resultRelevantScos.length === 0 ) {
            return true;
        }

        return resultRelevantScos.indexOf( scoId.toString() ) !== -1;
    }

    //revealing public api
    return {

        initialize: initialize,

        initializeNewSco:(scoId) => {
            if( !scoId ) {
                throw new Error( "SCO with id '" + scoId + "' isn't valid!." );
            }

            const sco = new ScoDataClass();
            scoValueMap.set( scoId, sco );
            return sco;
        },

        isEmpty: () => {
            return scoValueMap.size === 0;
        },

        contains: function( scoId ){
            return !!scoId && scoValueMap.has(scoId);
        },

        get: ( scoId ) => {
            return scoValueMap.get( scoId );
        },

        /**
         * @param scoId
         * @param key
         * @param value
         */
        setValue: ( scoId, key, value ) => {
            if( !scoValueMap.has( scoId ) ) {
                throw new Error( "No SCO with id '" + scoId + "' available." );
            }

            return scoValueMap.get( scoId ).setValue( key, value );
        },

        getValue: ( scoId, key ) => {
            if( !scoValueMap.has( scoId ) ) {
                throw new Error( "No SCO with id '" + scoId + "' available." );
            }

            return scoValueMap.get(scoId).getValue(key);
        },

        collectSuspendData: collectSuspendData,

        setRelevantScoList: function( scoList ){
            Assert.checkArgumentType( scoList, "string" );
            if( scoList.length > 0 ) {
                resultRelevantScos = scoList.split(",");
            }
        },

        anyResultRelevantScoHasBeenInitialized: function(){
            let result = false;
            forEachInitializedScoThatIsRelevantForResult( function(){
                result = true;
                return "break";
            });

            return result;
         },

        getStatus: function(){

            const scoAmount = resultRelevantScos.length > 0 ? resultRelevantScos.length : scoValueMap.size,
                  scoIterator = {
                      each: ( callback ) => forEachInitializedScoThatIsRelevantForResult( callback )
                  };

            return statusCollector.getStatus( scoIterator, scoAmount );
        }
    };
}
